import React from "react"
import { Alert, Typography, notification } from "antd"
import api from "src/api"
import { usePermission } from "src/hooks"
import { usePointsReport } from "./model"
import { downloadCsv } from "./model/query"
import { ReportFilters } from "./report-filters"
import { TodayCard } from "./today-card"
import { PointsBarChart } from "./bar-chart"
import { ReportTable } from "./report-table"
import { formatDate } from "./format"

// source: sent — наши операции, отправленные в Tillypad; tillypad — история Tillypad.
export function ReportTab({ source }) {
  const { hasPermission } = usePermission()
  const [isExporting, setIsExporting] = React.useState(false)
  const {
    period,
    report,
    today,
    categories,
    isLoading,
    isTodayLoading,
    handleSearch,
    refreshToday,
    exportQuery,
  } = usePointsReport(source)

  async function onExport() {
    setIsExporting(true)
    try {
      await downloadCsv(
        api,
        `bonus-points/daily/export?${exportQuery()}`,
        `bonus-points-${source}-${period.dateFrom}-${period.dateTo}.csv`,
      )
    } catch (error) {
      console.error("Ошибка выгрузки CSV", error)
      notification.error({ message: "Ошибка выгрузки CSV" })
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      {source === "sent" && <TodayCard today={today} isLoading={isTodayLoading} onRefresh={refreshToday} />}

      <ReportFilters
        period={period}
        categories={categories}
        onSearch={handleSearch}
        onExport={onExport}
        canExport={hasPermission("bonus-points.export")}
        isExporting={isExporting}
      />

      {source === "tillypad" && (
        <Alert
          style={{ marginBottom: 16 }}
          type="warning"
          showIcon
          message="История Tillypad неполная"
          description="Это история бонусов, которую видит клиент: кешбэк, траты на кассе, сгорание и наши же операции. Она подтягивается только у пользователей, которые открывали приложение, поэтому суммы занижены. Наши операции здесь тоже есть — складывать с разделом «Наши операции» нельзя."
        />
      )}

      <PointsBarChart rows={report?.rows ?? []} />
      <ReportTable rows={report?.rows ?? []} totals={report?.totals} isLoading={isLoading} />

      <Typography.Text type="secondary" style={{ display: "block", marginTop: 8 }}>
        Дни — по Москве. Прошедшие дни пересчитываются раз в час
        {report?.calculated_at ? ` (последний пересчёт ${formatDate(report.calculated_at)} UTC)` : ""}, сегодня — на лету.
        1 балл = 1 ₽.
      </Typography.Text>
    </>
  )
}
